import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import useSWR from "swr";

import type { THEOSetting } from "@spwn/types/firebase/firestore";
import type { SWRResponse } from "swr";

type UseGetPlayerSettingResult = {
  liveSetting: THEOSetting | null;
  vodSetting: THEOSetting | null;
};

type UseGetPlayerSetting = () => SWRResponse<UseGetPlayerSettingResult>;

export const useGetPlayerSetting: UseGetPlayerSetting = () => {
  return useSWR("getPlayerSetting", async () => {
    const [liveSetting, vodSetting] = await Promise.all([
      fetchPlayerLiveSetting(),
      fetchPlayerVodSetting(),
    ]);
    return {
      liveSetting,
      vodSetting,
    };
  });
};

const fetchPlayerLiveSetting = async () => {
  const snapshot = await firebase
    .firestore()
    .collection("THEOSettings")
    .doc("Live")
    .get();
  if (!snapshot.exists) return null;
  return snapshot.data() as THEOSetting;
};

const fetchPlayerVodSetting = async () => {
  const snapshot = await firebase
    .firestore()
    .collection("THEOSettings")
    .doc("VOD")
    .get();
  if (!snapshot.exists) return null;
  return snapshot.data() as THEOSetting;
};
